import Masonry from "react-masonry-css";
import {useEffect, useState} from "react";
import FunctionsData from "../../Functions/FunctionsData";
import VetDashboardViewLatest from "./VetDashboardViewLatest";

export default function VetDashboard({vet_id,setCurrent}) {
	const [loading,setLoading] = useState(true);
	const [data,setData] = useState([]);
	useEffect(() => {
		FunctionsData.fetchDataGet(
			FunctionsData.getApiUrl('/api/orders/vet/')+vet_id,
			setData,
			loading,
			setLoading
		)
	},[loading,vet_id]);

	const breakpointColumnsObj = {
		default: 3,
		1600:2,
		864: 1
	};

	return (
		<div style={{width:'100%'}}>
			<Masonry
				breakpointCols={breakpointColumnsObj}
				className="easyhr-masonry-grid"
				columnClassName="easyhr-masonry-grid_column">
				<VetDashboardViewLatest vet_id={vet_id} title={"today"} data={data} loading={loading} setCurrent={setCurrent} />
				<VetDashboardViewLatest vet_id={vet_id} title={"this week"} data={data} loading={loading} setCurrent={setCurrent} />
				<VetDashboardViewLatest vet_id={vet_id} title={"this month"} data={data} loading={loading} setCurrent={setCurrent} />
			</Masonry>
		</div>
	)

}
